// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rolycoly: PokeData = {
  "id": 837,
  "name": "rolycoly",
  "height": 3,
  "weight": 120,
  "base_experience": 48,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "tackle",
    "smokescreen",
    "rapid-spin",
    "ancient-power",
    "rock-blast",
    "rock-polish",
    "stealth-rock",
    "smack-down",
    "incinerate",
    "heat-crash"
  ],
  "moves": [
    "tackle",
    "ancient-power",
    "rock-blast",
    "stealth-rock",
    "seismic-toss",
    "stone-axe",
    "power-siphon",
    "stone-crush",
    "rock-throw",
    "rock-slide",
    "rock-smash",
    "boulder_bash",
    "rock-tomb"
  ],
  "evolution_chain": {
    "id": 441,
    "item": null,
    "species": [
      {
        "name": "rolycoly",
        "order": 837,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "carkol",
        "order": 838,
        "types": [
          PokeType.ROCK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 837,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "coalossal",
        "order": 839,
        "types": [
          PokeType.ROCK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 838,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 30,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
